export default[
	{
		path: '/change-password',
		name: 'ChangePassword',
		component: () => import('@/Modules/ChangePassword/Views/ChangePassword.vue'),
		meta : {
			title : 'Change Password'
		}
	},
	
	{
		path: '/profile/change-password',
		name: 'ProfileChangePassword',
		component: () => import('@/Modules/ChangePassword/Views/ProfileChangePassword.vue'),
		meta : {
			title : 'Profile Change Password'
		}
	},
]
